import styled, { css } from 'styled-components';

import { BodyProps } from './Body01';
import { getBodyFontWeight, getTypographyFontColor } from './helpers';

export const body02Styles = css<BodyProps>`
    font-family: ${ ({ theme }) => theme.type.regularFont };
    font-weight: ${ getBodyFontWeight };    
    color: ${ getTypographyFontColor };
    font-size: 0.875rem;
    letter-spacing: 0.17px;
    line-height: 20px;
    margin: 0;
    padding: 0;
`;

const Body02 = styled.p<BodyProps>`
    ${ body02Styles }
`;

export default Body02;
